import { useContext } from "react"
import { ErrorBannerContext } from "./ErrorBannerContext"
import type { ErrorBannerContextProps } from "./ErrorBannerContext"

export const useErrorBanner = (): ErrorBannerContextProps => useContext(ErrorBannerContext)
